const MyLscOtsMeetNavLinks = {
  MY_LSC_OTS_MEETS_ROOT: '/ots/meet/mylscotsmeets',
  MY_LSC_OTS_MEETS_SELECTION: '/ots/meet/mylscotsmeets/selection',
  MY_LSC_OTS_MEETS_SEARCH: '/ots/meet/mylscotsmeets/search'
};

export default MyLscOtsMeetNavLinks;